module.exports = __webpack_public_path__ + "static/4-ba692aaa056c139c843553019f0345c2.jpg";